export const FowlSoundEvents = {
    free_spin_spark: "fp_free_spin_spark",
    free_spin_land: "fp_free_spin_increment",
    // Transitions
    slot_transition: "fp_slot_transition",
    pick_transition: "fp_pick_transition",
    chicken_cluck: "cluck",
    // Bg
    geese_flying: "fp_geese_flying",
    geese_flying_stop: "fp_geese_flying_stop",
    banjo_playing: "fp_banjo_playing",
    tractor_driving: "fp_tractor_start",
    tractor_stop: "fp_tractor_stop",
} as const;
